import { getUserIsImpersonating } from "@faire/help-center-utils/serialized-data/getUser";
import snakeCase from "lodash/snakeCase";

const CHAT_SUPPORT_ISO_TO_COUNTRY_NAME = {
  AUS: "Australia",
  AUT: "Austria",
  BEL: "Belgium",
  CAN: "Canada",
  DNK: "Denmark",
  FIN: "Finland",
  FRA: "France",
  DEU: "Germany",
  GRC: "Greece",
  IRL: "Ireland",
  ITA: "Italy",
  LUX: "Luxembourg",
  NLD: "Netherlands",
  NZL: "New Zealand",
  NOR: "Norway",
  PRT: "Portugal",
  ESP: "Spain",
  SWE: "Sweden",
  CHE: "Switzerland",
  GBR: "United Kingdom",
  USA: "United States",
};

// @ts-prune-ignore-next
export const getZenDeskIssueTypeTag = (
  customerType: string,
  issueType: string
) => {
  if (customerType === "" || issueType === "") {
    return "";
  }
  return `${customerType.toLowerCase()}_${issueType
    .toLowerCase()
    .replace(/-/g, "_")}`;
};

export const getAllZenDeskTags = (
  countryISO: string,
  customerType: string,
  issueType: string
) => {
  const isImpersonating = getUserIsImpersonating();
  if (isImpersonating) {
    return `${getBasedInZenDeskTag(countryISO)}, ${getZenDeskCustomerTypeTag(
      customerType
    )}, ${getZenDeskIssueTypeTag(customerType, issueType)}, impersonated_user`;
  }
  return `${getBasedInZenDeskTag(countryISO)}, ${getZenDeskCustomerTypeTag(
    customerType
  )}, ${getZenDeskIssueTypeTag(customerType, issueType)}`;
};

export const getAllZenDeskTagsInArray = (
  countryISO: string,
  customerType: string,
  issueType: string,
  ...rest: string[]
) => {
  return [
    getBasedInZenDeskTag(countryISO),
    getZenDeskCustomerTypeTag(customerType),
    getZenDeskIssueTypeTag(customerType, issueType),
    ...rest,
  ];
};

const convertIsoToZenDeskLocationTag = (countryISO: string) => {
  if (countryISO === "GBR") {
    return "location_uk";
  }
  return `location_${snakeCase(
    CHAT_SUPPORT_ISO_TO_COUNTRY_NAME[
      countryISO as keyof typeof CHAT_SUPPORT_ISO_TO_COUNTRY_NAME
    ]
  )}`;
};

// @ts-prune-ignore-next
export const getBasedInZenDeskTag = (countryISO: string) => {
  if (!Object.keys(CHAT_SUPPORT_ISO_TO_COUNTRY_NAME).includes(countryISO)) {
    return "location_other";
  }
  return convertIsoToZenDeskLocationTag(countryISO);
};

const getZenDeskCustomerTypeTag = (customerType: string) => {
  switch (customerType) {
    case "retailer":
      return "retailer";
    case "brand":
      return "brand";
    default:
      return "retailer";
  }
};
